import './loader.css';

type TProps = {
  size?: number;
  className?: string;
};

export const SquareLoader = ({ size = 32, className }: TProps) => {
  return (
    <div
      className={`grid grid-cols-2 gap-[2px] w-fit ${className ?? ''}`}
      style={{ width: size, height: size }}
    >
      <div className="w-full h-full bg-[#DADADA] rectangle_1" />
      <div className="w-full h-full bg-[#DADADA] rectangle_2" />
      <div className="w-full h-full bg-[#DADADA] rectangle_3" />
      <div className="w-full h-full bg-[#DADADA] rectangle_4" />
    </div>
  );
};
